<template>
  <div>
    <MapCountries
      v-if="contentLoaded"
      :map-markers="mapMarkers"
      :options="{mode:'user'}"
    />
  </div>
</template>

<script>
export default {
  components: {
    MapCountries: () => import('@/components/map/MapCountries'),
  },

  data() {
    return {
      contentLoaded: false,
      mapMarkers: [],
    };
  },

  created() {
    this.loadMapMarkers();
  },

  mounted() {
    Bus.$on('map-markers:loaded', () => {
      this.loadMapMarkers();
    });

    Bus.$on('map-markers:refreshed', () => {
      this.loadMapMarkers();
    });
  },

  activated() {
    console.log('activated');
  },
  deactivated() {
    console.log('deactivated');
  },

  beforeDestroy() {
    Bus.$off('map-markers:loaded');
    Bus.$off('map-markers:refreshed');
  },

  methods: {
    async loadMapMarkers() {
      await this.$http
        .get('/api/admin/map/countries', {
          params: {},
        })
        .then((response) => {
          // console.log('response', response.data);
          this.mapMarkers = response.data;
        });

      console.log('map-markers.count', this.mapMarkers.length);

      if (this.mapMarkers.length) {
        this.contentLoaded = true;
      }
    },
  },
};
</script>
